import { withMetadata } from '../min/metadata'

import _parse from '../es6/parse'

export function parse() {
	return withMetadata(_parse, arguments)
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/libphonenumber-js/index.es6.exports/parse.js
// module id = 639
// module chunks = 0